import { getUrlWithVariant } from '@shopify/theme-product-form'

//takes variant, returns function that updates replaces window state
const updateVariantUrl = (variant) => {
  const urlWithoutQueryString = `${window.location.origin}${window.location.pathname}`;
  if (!variant) {
    window.history.replaceState({ ...window.history.state }, '', urlWithoutQueryString)
  } else {
    const variantUrl = getUrlWithVariant(urlWithoutQueryString, variant.id)
    window.history.replaceState({ ...window.history.state }, '', variantUrl)
  }
}

export default updateVariantUrl;